import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  submission(event) {
    if(!event.target.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
      event.target.classList.add("was-validated");
      event.target.querySelectorAll('.invalid-feedback').forEach(feedback => feedback.style.display = 'block')
    } else {
      event.target.querySelectorAll('.invalid-feedback').forEach(feedback => feedback.style.display = 'none')
    }
  }
}
